import React, { useState } from "react";
import styled, { css } from "styled-components";
import compileSyndicationsAppearancesCoverage from "../../utilities/compileSyndicationsPressCoverage";
import Globe from "../Globe";
import { ArrowUpRight } from "../Arrow";
import Button from "../Button";

const ArticleSyndicationList = ({ syndications = [], appearances = [], coverage = [] }) => {
  
  const compiled = compileSyndicationsAppearancesCoverage( syndications, appearances, coverage );
  const countries = compiled.countries;

  const [isExpanded, setIsExpanded] = useState(true);
  const [view, setView] = useState("country");

  const slugify = ( text ) => {
    return text

      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-");
  };

  const handleClick = (e) => {
    e.preventDefault();
    window.location.hash = slugify(e.target.innerText);
  }

  return (
    <StyledArticleSyndications>
      <summary>
        <Button as="span" className="is-small">View Syndications</Button>
      </summary>
      {/*<div>
        {countries.map(( country, index ) => (
          <a href={`#${slugify(country.name)}`} title={country.name}>{country.name}</a>
        ))}
        </div>*/}
      <ul>
      {countries.map(( country, index ) => (
        <>
          {country.outlets.map(( outlet, index ) => {
            return (
              <>
                {outlet.items.map(( item, index ) => {
                  const url = item?.youtube_url ? item.youtube_url : (
                    item?.url ? item.url : false
                  );
                  const itemType = item.item_type === 'appearance' ? item?.medium_format?.name : item.item_type;
                  return (
                    <StyledOutletListItem key={`${country}-${outlet.id}-${index}`}>
                      <strong>{country.name}</strong>
                      <h3>{outlet.name}</h3>
                      {url ? (
                        <h2><a href={url} target="_blank" rel="noopener noreferrer" title={`Read on ${item.outlet.name}`}>{item.title}</a></h2>
                      ) : (
                        <h2>{item?.medium?.name === "Newsletter" && "Newsletter: "}{item.title}</h2>
                      )}
                      <span>{item?.language?.name} / {item?.medium?.name}</span>
                      {url && (
                        <a href={url} target="_blank" rel="noopener noreferrer" title={`Read on ${item.outlet.name}`}>
                           <ArrowUpRight />
                        </a>
                      )}
                    </StyledOutletListItem>
                    )
                })}
              </>
            )
          })}
        </>
      ))}
      </ul>
    </StyledArticleSyndications>
  );
};

export default ArticleSyndicationList;


const StyledArticleSyndications = styled.details`
  position: relative;
  display: grid;
  list-style-type: none;
  padding: 0 1.5em 4em;
  z-index: 5;
  @media ( min-width: 48em ) {
    margin-top: -4em;
  }
  summary {
    
    &::-webkit-details-marker {
      display: none;
    }
    &::marker {
      display: none;
    }
    display: grid;
    place-items: center;
  }
  > div {
    position: sticky;
    z-index: 2;
    top: 0.25em;
    display: flex;
    gap: 1em;
    padding: 1em 0;
    user-select: none;
    background-color: var(--theme-background-dark);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    --size: 0.25em;
    &::-webkit-scrollbar {
      width: var(--size);
      height: var(--size);
      border-radius: 0.5em;
    }
    &::-webkit-scrollbar-track {
      width: var(--size);
      height: var(--size);
      border-radius: 0;
    }
    &::-webkit-scrollbar-thumb {
      height: 0.25em;
      width: 0.25em;
      background: #333;
      //border: 2px solid #dfdfdf;
      border-radius: 0;
    }
    a {
      display: block;
      padding: 0.625em 0.75em 0.5em;
      background-color: #1e1e1e;
      line-height: 1;
      white-space: nowrap;
    }
  }
  > ul {
    display: grid;
    grid-template: auto / 1fr;
    gap: 1.5em;
    list-style: none;
    padding: 2em 0;
    margin: 0;
    @media ( min-width: 48em ) {
      grid-template: auto / 1fr 1fr;
    }
    @media ( min-width: 48em ) {
      grid-template: auto / 1fr 1fr;
    }
    @media ( min-width: 60em ) {
      grid-template: auto / 1fr 1fr 1fr;
    }
  }
`;

const StyledOutletListItem = styled.li`
  position: relative;
  background-color: rgba(255,255,255,0.05);
  backdrop-filter: blur(4px) saturate(0);
  padding: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1em;
  strong {
    margin: 0;
    font-size: 0.75em;
    text-transform: uppercase;
  }
  h3 {
    font-size: 1em;
    font-weight: 700;
    font-family: var(--font-heading);
    text-transform: uppercase;
    margin: 0;
    line-height: 1;
  }
  h2 {
    margin: 0 0 0.5em;
    line-height: 1.4;
    font-size: 1.375em;
  }
  > span {
    margin-top: auto;
    font-size: 0.6875em;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
  > a {
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: currentColor;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }
  svg {
    position: absolute;
    top: 1em;
    right: 1em;
    opacity: 0.2;
    font-size: 0.75em;
    transition: opacity 0.3s ease;
  }
  .can-hover & > a:hover,
  & > a:active {
    &::before {
      opacity: 0.1;
    }
    svg {
      opacity: 1;
    }
  }
`;

const StyledSyndicationListItem = styled.li`
  display: grid;
  grid-template: auto / 1fr;
  grid-gap: 0.5em;
  &:not(:last-of-type) {
    border-bottom: 1px dashed rgba(0,0,0,0.2);
    margin-bottom: 0.5em;
    padding-bottom: 0.75em;
  }
  a {
    text-decoration-line: underline;
    text-decoration-thickness: 0.75px;
    text-underline-offset: 0.1em;
    text-decoration-color: var(--theme-text-against-dark-medium);
    .can-hover &:hover,
    &:active {
      text-decoration-thickness: 0;
      text-decoration: none;
      span {
        background-color: var(--theme-background-dark);
        color: var(--theme-text-against-dark);
      }
    }
  }
  > span {
    font-size: 0.625em;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    background-color: rgba(255,255,255,0.1);
    border-radius: var(--border-radius);
    justify-self: start;
    padding: 0.25em 0.5em;
  }
`;

